import { ApplicationForm } from 'ui/components/company/patterns/ApplicationForm/ApplicationForm';

/**
 * 売り手企業公開申請
 */
export const CompanyApplication: React.FC = () => {
    return <ApplicationForm />;
};
